import Rest from './rest';

const RESOURCE = "hotel";

export default {

    filterHotels: function (params) {
        return Rest.get(RESOURCE, {params})
    },
    listActiveHotels: function () {
        return Rest.get(`${RESOURCE}/active`, {})
    },
    listAllHotels: function () {
        return Rest.get(`${RESOURCE}/all`, {})
    },
    getHotel: function (hotelId) {
        return Rest.get(`${RESOURCE}/${hotelId}`);
    },
    addHotel: function (data) {
        return Rest.post(RESOURCE, data);
    },
    updateHotel: function (hotelId, data) {
        return Rest.put(`${RESOURCE}/${hotelId}`, data);
    },
    toggleHotelState: function (hotelId, status) {
        return Rest.patch(`${RESOURCE}/${hotelId}`,null, {params: {status}});
    },
};



// WEBPACK FOOTER //
// ./src/services/HotelService.js